import { Link } from 'react-router-dom';

import ImgSlot from '@/ui/ImgSlot';
import { fmtDate, type FormattedDate } from '@/lib/format';
import type { ArchiveEvent, Language } from '@/types';

import styles from './ArchiveCard.module.css';

interface ArchiveCardProps {
  event: ArchiveEvent;
  lang: Language;
  index: number;
}

export default function ArchiveCard({ event, lang, index }: ArchiveCardProps) {
  const dd: FormattedDate = fmtDate(event.date, lang);
  return (
    <Link to={`/events/${event.id}`} className={styles.root}>
      <ImgSlot
        className={styles.image}
        src={event.posterUrl}
        alt={event.title}
      />
      <div className={styles.metaRow}>
        <span>{event.code}</span>
        <span>{event.venue === 'hayfilm' ? 'HAYFILM' : 'AYRARAT'}</span>
      </div>
      <h3 className={styles.title}>{event.title}</h3>
      <div className={styles.lineup}>{event.headliners.join(' / ')}</div>
      <div className={styles.metaRow}>
        <span>
          {dd.day} {dd.month} {dd.year}
        </span>
        <span>+ /{String(index + 1).padStart(3, '0')}</span>
      </div>
    </Link>
  );
}
